// extracted by mini-css-extract-plugin
export default {"services":"Services_services__YYzVp","servicesText":"Services_servicesText__OI9cH","servicesContainer":"Services_servicesContainer__yTpin"};